import React, { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import "./AdminLayout.css";
import adminProfileImg from "../assets/guide.png"

export default function AdminLayout() {
  const navigate = useNavigate();
  const [isAuthed, setIsAuthed] = useState(false);

  const decodeToken = (t) => {
    try {
      const payload = t.split(".")[1];
      return JSON.parse(atob(payload));
    } catch (e) {
      return null;
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("adminToken");
    const decoded = token ? decodeToken(token) : null;

    if (!token || !decoded || decoded.role !== "admin") {
      localStorage.removeItem("adminToken");
      navigate("/admin/login", { replace: true });
    } else {
      setIsAuthed(true);
    }
  }, [navigate]);

  // Block rendering until auth is confirmed — prevents child components
  // from mounting and firing unauthenticated API requests.
  if (!isAuthed) {
    return null;
  }

  return (
    <div className="al-root">
      <Sidebar />

      <main className="al-main">
        <header className="al-topbar">
          <h1 className="al-title">Dashboard</h1>
          <div className="al-actions">
            <div className="al-search">
              <input placeholder="Search..." />
            </div>
            <button className="al-icon" title="Settings">⚙️</button>
            <button className="al-icon" title="Notifications">🔔</button>
            <div className="al-avatar">
              <img
                src={adminProfileImg}
                alt="A"
              />
            </div>
          </div>
        </header>

        <div className="al-content">
          {/* Every admin page will render here */}
          <Outlet />
        </div>
      </main>
    </div>
  );
}

